import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=c6314304&scoped=true"
import script from "./menuList.vue?vue&type=script&lang=ts"
export * from "./menuList.vue?vue&type=script&lang=ts"
import style0 from "./menuList.vue?vue&type=style&index=0&id=c6314304&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6314304",
  null
  
)

export default component.exports